module.exports = __webpack_public_path__ + "img/poly-10.6c9f3c30.png";